import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

import Fab from "@material-ui/core/Fab";
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import BuildIcon from "@material-ui/icons/Build";
import BlockIcon from "@material-ui/icons/Block";

import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import {APOLLO_GROUP_OPERATOR, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../../atom/Apollo_Authorization";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { 
  apollo_useStyles, 
  valueToOption, 
  options_status, 
  options_use_preference,
} from "../../../atom/Apollo_styles";
import { 
  list_poseidon_userlist_path,
  apollo_users_path,
  userlisteditposeidon_path,
} from "../../../atom/Apollo_links";
import GenericTemplate from "../../../templates/GenericTemplate";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";

import { Status } from "../../SEGMENT/poseidon/SegmentModel";
import { ListUserList, ResListUserLists } from "./UserListModel";
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";
import { ApolloDataTable, STORAGE_KEY } from "../../../atom/Apollo_DataTable";

import moment from "moment";
import "moment/locale/ja";
import { MUISortOptions, SelectableRows } from "mui-datatables";

/*
    画面名：ユーザーリスト一覧
 */
const UserListTop: React.FC = () => {
  const history = useHistory();
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);

  const [userLists, setUserLists] = useState<ResListUserLists[]>([]);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: 9,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  React.useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    let url: string = apollo_users_path;
    ApolloAxios.get(url).then(response => {
      let result1 = response.data.result;

      var request: ListUserList = {
        accountId: state.current.accountId,
      };

      url = list_poseidon_userlist_path;
      ApolloAxios.post(url, request).then(response => {
        let resultCode: number = response.data.resultCode;

        if (resultCode < 0 || resultCode === 2) {
          let type1: string = "error";
          if (resultCode === 2) {
            type1 = "info"
          }

          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: type1,
              message: response.data.message,
            }
          });
          
          return;
        }

        let userLists1: ResListUserLists[] = [];

        response.data.forEach(function(data: any) {
          // UU
          let uuData: number = data.uu;
          if (data.uu === undefined) {
            uuData = 0;
          }

          // 利用設定 値セット
          let usePreference1: string = "";

          if (data.usePreference !== undefined) {
            if (data.usePreference.length === 1) {
              usePreference1 = valueToOption(data.usePreference[0], options_use_preference).label;
            } else if (data.usePreference.length === 2) {
              usePreference1 = "カスタムリストに利用・除外リストに利用";
            }
          }

          let updatedBy: string = "";
          result1.forEach(function(res1: any) {
            if (data.updatedBy === res1.userId) {
              updatedBy = res1.familyName+" "+res1.firstName;
            }
          });

          let userList1: ResListUserLists = {
            id: data.id,
            name: data.name,
            status: data.status,
            uu: uuData,
            usePreference: usePreference1,
            updatedAt: data.updatedAt,
            updatedBy: updatedBy,
          };
          userLists1.push(userList1);
        });

        setUserLists(userLists1);
      }).catch(err => {
        const errMsg = `ユーザーリスト情報の取得に失敗しました。`
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          }
        });
      });
    }).catch(err => {
      const errMsg = `ユーザー情報の取得に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
      // if (err.redirecturl != "" && err.redirecturl !== undefined) {
      //   const url = err.redirect + history.location.pathname;
      //   history.push( url );
      // }
    }).finally(() => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
    });
  }, []);

  const classes = apollo_useStyles();
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <Tooltip title={valueToOption(value, options_status).label}>
              <span>
                {value === Status.Available ? (
                  <img
                    src={"/img/poseidon/success.png"}
                    alt="利用可"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Processing ? (
                  <img
                    src={"/img/poseidon/loading.gif"}
                    alt="処理中"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Invalid ? (
                  <img
                    src={"/img/poseidon/invalid.png"}
                    alt="無効"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Validating ? (
                  <img
                    src={"/img/poseidon/validating.png"}
                    alt="検証中"
                    height="32"
                    width="auto"
                  />
                ) : (
                  <img
                    src={"/img/poseidon/error.png"}
                    alt="利用不可"
                    height="32"
                    width="auto"
                  />
                )}
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "name",
      label: "ユーザーリスト名",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any) => {
          return (
            <Tooltip title={value}>
              <span>{value}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "uu",
      label: "UU",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => {
          return value.toLocaleString();
        },
      },
    },
    {
      name: "usePreference",
      label: "利用設定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          let splitVal: string[] = [];

          if (value !== "") {
            splitVal = value.split("・")
          }

          return value ? (
            <Tooltip title={value}>
              <span>
                {splitVal.length > 1 ?
                  <>
                  <BuildIcon />
                  <BlockIcon />
                  </>
                : splitVal.length === 1 ?
                  splitVal[0] === "カスタムリストに利用" ? <BuildIcon /> : <BlockIcon />
                : ""
                }
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "updatedBy",
      label: "最終更新ユーザー",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <p>{value}</p>
          );
        },
      },
    },
    {
      name: "updatedAt",
      label: "最終更新",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <Tooltip
              title={moment(value).format("YYYY/MM/DD HH:mm:ss")}
            >
              <span>{moment(value).fromNow()}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: number, tableMeta: any) => {
          let userListId: number = tableMeta.rowData[0];
          let isEdit: boolean = false;
          let status: string = "";

          userLists.forEach(function(userList: any) {
            if (userList.id === userListId) {
              status = userList.status;
            }
          });

          if (status === Status.Available || status === Status.Unavailable || status === Status.Invalid) {
            isEdit = true;
          }

          return isEdit ? (
            <Tooltip title="ユーザーリスト編集" placement="top">
              <KeyboardArrowRightIcon
                onClick={() =>
                  history.push(`${userlisteditposeidon_path}${userListId}`)
                }
                className={classes.link}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
          ) : (
            ""
          );
        },
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "id",
    direction: "asc",
  };
  const selectableRows: SelectableRows = "none";
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.USER_LIST) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.USER_LIST,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  };

  return (
    <div>
      <GenericTemplate title={""}>
        <CustomizedSnackbars />
        <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
          <ApolloBreadcrumbs2 data={breadcrumbsData}/>

          <Tooltip title="ユーザーリスト新規作成" placement="bottom">
            <Link to={`${userlisteditposeidon_path}0`} className={classes.link}>
              <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                <AddIcon />
              </Fab>
            </Link>
          </Tooltip>

          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              title=""
              data={userLists ? userLists : []}
              columns={columns}
              options={options}
            />
          </Card>
        </ApolloPageUsagePermission>
      </GenericTemplate>
    </div>
  );
};

export default UserListTop;
